import React from 'react';

export interface ChatMessagePartTextContainerProps {
  children: React.ReactNode;
}

function ChatMessagePartTextContainer({
  children,
}: ChatMessagePartTextContainerProps) {
  return <div className='chat-message-text w-full block h-fit'>{children}</div>;
}

export default React.memo(ChatMessagePartTextContainer);
